export default __webpack_public_path__ + "static/media/scraping.9e721d70.png";